
// 审核快照ua
const auditClientUserAgent = [
  'Mozilla/5.0 (Linux; Android 5.0; SM-G900P Build/LRX21T) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/73.0.3679.0 Mobile Safari/537.36',
  'Mozilla/5.0 (iPad; CPU OS 11_0 like Mac OS X) AppleWebKit/604.1.34 (KHTML, like Gecko) Version/11.0 Mobile/15A5341f Safari/604.1',
];
// 审核快照设备尺寸
const auditClientScreen = '360*640*3';


/**
 * 设备号和ua都相同才认为是审核快照
 */
export const verifyAuditClient = () => {
  const screen = [window.screen.width, window.screen.height];
  window.devicePixelRatio && screen.push(window.devicePixelRatio);

  const isEqualScreen =  auditClientScreen === screen.join('*');

  const isEqualUA = auditClientUserAgent.indexOf(navigator.userAgent) > -1;

  return isEqualScreen && isEqualUA;
};
